import React, { useState } from "react";
import NavbarCustom from "../../../Components/NavbarCustom";
import BackBtn from "../../../Components/BackBtn/BackBtn";
import "./sendOtp.css";
import Swal from "sweetalert2";
import { useForgetPassword  } from "../../../APIContext/ForgetPasswordContext";

export default function SendOTP() {
  const { loading, functionSendOTP } = useForgetPassword ();
  const [inEmail, setInEmail] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);

  const handleSendOtp = async () => {
    if (!inEmail) {

       Swal.fire({
            icon: "error",
            title: "Error",
            text: "Please enter your email",
            confirmButtonColor: "#B79527", // orange / gold
      cancelButtonColor: "#1C1C1C",
          });
      return;
    }
    setIsDisabled(true);

    let data = {email : inEmail};

    try{
      await functionSendOTP(data)
      setIsDisabled(false);
    }catch (err){
      setIsDisabled(false);
    }
  };

  return (
    <>
      <NavbarCustom />

      <div className="otp-container">
        <div className="otp-header">

          <div className="otp-header-content">
            <h1 className="otp-heading black-text-clip">Verify Your Email</h1>
            <p className="black-text-clip text-center">Enter your email to receive OTP</p>
          </div>
        </div>

        <div className="otp-input-section">
          <label className="black-text-clip">Email Address</label>
          <input
            type="email"
            placeholder="Enter your email"
            className="otp-input"
            value={inEmail}
            onChange={(e) => setInEmail(e.target.value)}
          />
        </div>

        <div className="otp-btn-container">
          <button
            className="otp-btn"
            disabled={isDisabled}
            onClick={handleSendOtp}
            style={
              isDisabled
                ? { cursor: "not-allowed", background: "rgb(0 0 0 / 78%)" }
                : {}
            }
          >
            {isDisabled ? "Sending..." : "Send OTP"}
          </button>
        </div>
      </div>
    </>
  );
}
